import { useTheme } from '@mui/material/styles';

export const Divider = () => {
  const theme = useTheme();

  return (
    <hr style={{ border: `1px solid ${theme.palette.primary.main}`, marginBlock: 5 }}></hr>
  )
}
